/**
 * input component for input macro in form.twig
 *
 * name: name of the field
 * value: value of the field
 * files: files of the field
 * show: show the password value
 * liveChangeEvent: the live change event describes, if a change event should be dispatched with every letter
 *                  false: change event is only dispatched, when focus is gone from the field
 *                  true: change event is dispatched for every letter (e.g. accountant directory filter)
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('input', (config) => ({
        name: config.name ,
        value: config.value ?? '',
        files: config.files ?? null,
        show: config.show ?? false,
        attachment_placeholder: '',
        liveChangeEvent: config.liveChangeEvent ?? false,
        init() {
            // Same effect like $watch
            Alpine.effect(() => {
                if(this.value.length > 0) {
                    this.$el.classList.add('is-focused');
                } else {
                    this.$el.classList.remove('is-focused');
                }
            })

            if (this.liveChangeEvent) {
                this.$watch('value', (value) => {
                    /* manually trigger change event to activate change event while typing (e.g. accountant directory filter or form mobiliar distribution key)*/
                    let input = document.querySelector('[name=' + this.name + ']');
                    input.dispatchEvent(new Event('change'));
                    if (value.length > -1 && input === document.activeElement) {
                        this.$el.classList.add('is-focused');
                    } else {
                        // Do not remove the is-focused class if the input is an attachment
                        if (this.name !== 'attachment') {
                            this.$el.classList.remove('is-focused');
                        }
                    }
                });

            }

            // set correct background label color
            window.domUtils.setBackgroundColor(this.$el);
            if (this.name === 'attachment') {
                window.domUtils.setBackgroundColor(this.$el,'.files-placeholder');
            }
        },
    }));
});
